import { render, staticRenderFns } from "./AddSectionModal.vue?vue&type=template&id=551681a5&"
import script from "./AddSectionModal.vue?vue&type=script&lang=ts&"
export * from "./AddSectionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports